import { z } from 'zod';
import { timestampSchema } from '../task/task';

/** A source site's domain (QZ-D58): lower-case labels, at least one dot, no scheme/path/port. */
export const domainSchema = z
  .string()
  .max(253)
  .regex(/^(?=.{1,253}$)([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/);

/** The source sites a new environment starts with (QZ-D58). */
export const SEED_SOURCE_SITES = ['wikipedia.org'] as const;

/** The most source sites the list may hold at once (QZ-D58). */
export const MAX_SOURCE_SITES = 20;

/** A source site admins research on, and when it was added (QZ-D58). */
export const sourceSiteSchema = z
  .object({ domain: domainSchema, addedAt: timestampSchema })
  .strip();
export type SourceSite = z.infer<typeof sourceSiteSchema>;

/**
 * The domain an admin meant: trims, lower-cases, and strips a scheme, `www.`, a path, query,
 * fragment and port. `https://en.wikipedia.org/wiki/Paris` → `en.wikipedia.org`. Undefined
 * if what remains is not a domain (QZ-D58).
 */
export const domainFromInput = (input: string): string | undefined => {
  let value = input.trim().toLowerCase();
  value = value.replace(/^[a-z][a-z0-9+.-]*:\/\//, '');
  value = value.split(/[/?#]/)[0] ?? '';
  value = value.replace(/:\d+$/, '');
  value = value.replace(/^www\./, '');
  return domainSchema.safeParse(value).success ? value : undefined;
};
